import moment from 'moment'
import { dateFormat, dateTimeFormat } from '../constants/dateFormat'

export const formatDate = (date?: Date, forceFormat?: string) => {
  if (!date) return ''

  return moment(new Date(date)).format(forceFormat || dateFormat)
}

export const formatDateTime = (date?: Date, forceFormat?: string) => {
  if (!date) return ''

  return formatDate(date, forceFormat ?? dateTimeFormat)
}

export const formatDateTimeConditional = (date?: Date, forceFormat?: string) => {
  if (!date) return ''

  const dateDate = typeof date === 'string' ? new Date(date) : date
  const hours = dateDate.getHours()
  const minutes = dateDate.getMinutes()
  return (hours > 0 || minutes > 0)
    ? formatDate(date, forceFormat ?? dateTimeFormat)
    : formatDate(date, forceFormat)
}

